/// <amd-module name="Artifacts/FeedSettings/redux/Module" />

import { IFeedSettingsHubState } from "Artifacts/FeedSettings/redux/Contracts";
import { feedSettingsHubReducer } from "Artifacts/FeedSettings/redux/Reducer";
import rootSaga from "Artifacts/FeedSettings/redux/Sagas";
import { combineReducers } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

export interface IFeedSettingsModuleState {
  "feed-settings": IFeedSettingsState;
}

interface IFeedSettingsState {
  hubState: IFeedSettingsHubState;
}

const _feedSettingsModule: ISagaModule<IFeedSettingsModuleState> = {
  id: "feed-settings",
  reducerMap: {
    ["feed-settings"]: combineReducers({ hubState: feedSettingsHubReducer }),
  },
  sagas: [rootSaga],
};

export const FeedSettingsModule = [_feedSettingsModule];
